import pi01 from 'assets/can-store/modernTemplate/pi-01-01.jpg';
import pi02 from 'assets/can-store/modernTemplate/pi-01-02.jpg';
import pi03 from 'assets/can-store/modernTemplate/pi-01-03.jpg';
import pi04 from 'assets/can-store/modernTemplate/pi-01-04.jpg';
// import pi05 from 'assets/can-store/modernTemplate/pi-01-05.jpg';
// import pi06 from 'assets/can-store/modernTemplate/pi-01-06.jpg';
// import pi07 from 'assets/can-store/modernTemplate/pi-01-07.jpg';
// import pi08 from 'assets/can-store/modernTemplate/pi-01-08.jpg';

/** @deprecated */
type ProductType = {
	id: number;
	brand: string;
	category: string;
	title: string;
	price: number;
	description: string;
	images: string[];
	rating: number;
};

/** @deprecated */
const product: ProductType = {
	id: 1,
	brand: 'Bearington Collection',
	category: 'Plush',
	title: 'Golden Retriever',
	price: 33.99,
	description:
		'Sweet puppy introduces an irresistibly adorable golden retriever puppy, capturing hearts with its soft fur, sparkling eyes, and a flexible, floppy body that can be arranged in various postures - sitting, standing, or laying, extending to a length of 13”. Crafted with meticulous attention to detail, it features high-quality plush materials, air-brushed details, and an expressive face, forging a lifelike companion that boasts a striking resemblance to a real puppy. Not only does it serve as a heartwarming present, perfect for little boys, girls, and dog enthusiasts of all ages, but its delicately stuffed body and bean bag-weighted paws also make this puppy a snugly, huggable friend. Coming to you from the award-winning Bearington Collection, this delightful puppy is recognized globally for its luxurious fabrics and exemplary quality, promising not just a toy, but a cherished keepsake.',
	images: [pi01, pi02, pi03, pi04],
	rating: 5,
};

export default product;
